<template>
    <span class="invalid-feedback" role="alert" style="display: block;" v-if="message">
        <strong>{{ message }}</strong>
    </span>
</template>

<script>
export default {
    name: "Feedback",
    props: ['message']
}
</script>

<style scoped>

</style>
